<div class="p-4">
  <div class="flex justify-end">
    <ion-icon name="close" (click)="dismiss()"></ion-icon>
  </div>
  <div>
    <div class="flex justify-center">
      <h2>
        <div>{{ 'shared.attention' | translate }}</div>
      </h2>
    </div>
  </div>
  <p class="text-center p-3 text-lg">
    <span>{{ 'onboarding.customer.data.modal.header' | translate }}</span>
  </p>
  <div class="flex p-2 text-lg">
    <div class=" mx-auto my-5 justify-center text-center">
      <div>
        <span>{{ 'shared.customer.name' | translate }}: <strong>{{ name }}</strong></span>
      </div>
      <div>
        <span>{{ 'shared.customer.surname' | translate }}: <strong>{{ surname }}</strong></span>
      </div>
      <div>
        <span>{{ 'shared.customer.vat' | translate }}: <strong>{{ vat }}</strong></span>
      </div>
    </div>
  </div>
  <p class="text-center text-lg">
  <span><strong>{{ 'onboarding.customer.data.modal.canYouConfirm' | translate }}</strong></span>
  </p>
  <p class="flex justify-center p-5">
    <app-filled-button
      class="text-2xl flex-1"
      expand="full"
      textSize="lg"
      (click)="dismiss()"
    >
      {{ 'onboarding.customer.data.modal.negate' | translate }}
    </app-filled-button>
  </p>
  <p class="flex justify-center text-center p-5">
    <app-link class="text-sm" color="primary" (click)="confirm()">
      {{ 'onboarding.customer.data.modal.confirm' | translate }}
    </app-link>
  </p>
</div>
